import * as analytics from '@opendoor/shared-fe/build/analytics';
import { trackPageView as sharedTrackPageView } from '@opendoor/shared-fe/build/trackPageView';

import * as matchers from './pathMatchers';

interface ITrackPageView {
  pathname: string;
  search: string;
}

export default function trackPageView({ pathname, search }: ITrackPageView): void {
  sharedTrackPageView({ pathname, search });
  const slug = matchers.matchSellerFlowSlug(pathname);
  const page = matchers.matchSellerFlowPageName(pathname);
  if (slug) {
    analytics.trackEvent('seller-flow', 'view', 'slug', {
      lead_token: matchers.matchLeadToken(pathname),
      slug,
    });
    analytics.register({ seller_flow_last_viewed_slug: slug, seller_flow_last_viewed: `/${slug}` });
  } else if (page) {
    analytics.trackEvent('seller-flow', 'view', 'page', {
      lead_token: matchers.matchLeadToken(pathname),
      page,
    });
    analytics.register({
      seller_flow_last_viewed_page: page,
      seller_flow_last_viewed: `/p/${page}`,
    });
  } else if (matchers.matchResaleOfferPortalPageName(pathname)) {
    analytics.trackEvent('resale-offer-portal', 'view', 'page', {
      page: matchers.matchResaleOfferPortalPageName(pathname),
    });
  }
}
